"use strict";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { newObj[key] = obj[key]; } } } newObj.default = obj; return newObj; } }

var _MMSR5JSJcjs = require('./MMSR5JSJ.cjs');



var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');


var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/composite/composite-store.ts
var _compositestore = require('@ariakit/core/composite/composite-store'); var Core = _interopRequireWildcard(_compositestore);
function useCompositeStoreOptions(props) {
  const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
  return { id, ...props };
}
function useCompositeStoreProps(store, update, props) {
  store = _MMSR5JSJcjs.useCollectionStoreProps.call(void 0, store, update, props);
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "activeId", "setActiveId");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "includesBaseElement");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "virtualFocus");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "orientation");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "rtl");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "focusLoop");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "focusWrap");
  _FH6HQ5JNcjs.useStoreProps.call(void 0, store, props, "focusShift");
  return store;
}
function useCompositeStore(props = {}) {
  props = useCompositeStoreOptions(props);
  const [store, update] = _FH6HQ5JNcjs.useStore.call(void 0, Core.createCompositeStore, props);
  return useCompositeStoreProps(store, update, props);
}





exports.useCompositeStoreOptions = useCompositeStoreOptions; exports.useCompositeStoreProps = useCompositeStoreProps; exports.useCompositeStore = useCompositeStore;
